// extracted by mini-css-extract-plugin
export default {"body":"modalZendeskDetails_body__nirDO"};